module.exports = __webpack_public_path__ + "static/media/mohsin.d0cddd44.jpg";